import { baseApi } from './base';
import { Language } from '../../types/interfaces';

export const getLanguages = async () => {
  const response = await baseApi.get<Language[]>(`/v1/public/language`);

  return response.data;
};
